// Popular countries (shown at top)
const popularCountries = [
  { code: '+91', country: 'India', flag: '🇮🇳', minLength: 10, maxLength: 10, popular: true },
  { code: '+1', country: 'USA/Canada', flag: '🇺🇸', minLength: 10, maxLength: 10, popular: true },
  { code: '+44', country: 'UK', flag: '🇬🇧', minLength: 10, maxLength: 10, popular: true },
  { code: '+971', country: 'UAE', flag: '🇦🇪', minLength: 9, maxLength: 9, popular: true },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦', minLength: 9, maxLength: 9, popular: true },
  { code: '+65', country: 'Singapore', flag: '🇸🇬', minLength: 8, maxLength: 8, popular: true },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾', minLength: 9, maxLength: 10, popular: true },
];

// All countries list (alphabetically sorted)
const allCountriesList = [
  { code: '+93', country: 'Afghanistan', flag: '🇦🇫', minLength: 9, maxLength: 9 },
  { code: '+355', country: 'Albania', flag: '🇦🇱', minLength: 9, maxLength: 9 },
  { code: '+213', country: 'Algeria', flag: '🇩🇿', minLength: 9, maxLength: 9 },
  { code: '+1', country: 'USA/Canada', flag: '🇺🇸', minLength: 10, maxLength: 10 },
  { code: '+376', country: 'Andorra', flag: '🇦🇩', minLength: 6, maxLength: 9 },
  { code: '+244', country: 'Angola', flag: '🇦🇴', minLength: 9, maxLength: 9 },
  { code: '+54', country: 'Argentina', flag: '🇦🇷', minLength: 10, maxLength: 11 },
  { code: '+374', country: 'Armenia', flag: '🇦🇲', minLength: 8, maxLength: 8 },
  { code: '+61', country: 'Australia', flag: '🇦🇺', minLength: 9, maxLength: 9 },
  { code: '+43', country: 'Austria', flag: '🇦🇹', minLength: 10, maxLength: 13 },
  { code: '+994', country: 'Azerbaijan', flag: '🇦🇿', minLength: 9, maxLength: 9 },
  { code: '+973', country: 'Bahrain', flag: '🇧🇭', minLength: 8, maxLength: 8 },
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩', minLength: 10, maxLength: 10 },
  { code: '+375', country: 'Belarus', flag: '🇧🇾', minLength: 9, maxLength: 9 },
  { code: '+32', country: 'Belgium', flag: '🇧🇪', minLength: 9, maxLength: 9 },
  { code: '+501', country: 'Belize', flag: '🇧🇿', minLength: 7, maxLength: 7 },
  { code: '+229', country: 'Benin', flag: '🇧🇯', minLength: 8, maxLength: 8 },
  { code: '+975', country: 'Bhutan', flag: '🇧🇹', minLength: 8, maxLength: 8 },
  { code: '+591', country: 'Bolivia', flag: '🇧🇴', minLength: 8, maxLength: 8 },
  { code: '+387', country: 'Bosnia', flag: '🇧🇦', minLength: 8, maxLength: 9 },
  { code: '+267', country: 'Botswana', flag: '🇧🇼', minLength: 8, maxLength: 8 },
  { code: '+55', country: 'Brazil', flag: '🇧🇷', minLength: 10, maxLength: 11 },
  { code: '+673', country: 'Brunei', flag: '🇧🇳', minLength: 7, maxLength: 7 },
  { code: '+359', country: 'Bulgaria', flag: '🇧🇬', minLength: 9, maxLength: 9 },
  { code: '+226', country: 'Burkina Faso', flag: '🇧🇫', minLength: 8, maxLength: 8 },
  { code: '+257', country: 'Burundi', flag: '🇧🇮', minLength: 8, maxLength: 8 },
  { code: '+855', country: 'Cambodia', flag: '🇰🇭', minLength: 8, maxLength: 9 },
  { code: '+237', country: 'Cameroon', flag: '🇨🇲', minLength: 9, maxLength: 9 },
  { code: '+238', country: 'Cape Verde', flag: '🇨🇻', minLength: 7, maxLength: 7 },
  { code: '+236', country: 'Central African Republic', flag: '🇨🇫', minLength: 8, maxLength: 8 },
  { code: '+235', country: 'Chad', flag: '🇹🇩', minLength: 8, maxLength: 8 },
  { code: '+56', country: 'Chile', flag: '🇨🇱', minLength: 9, maxLength: 9 },
  { code: '+86', country: 'China', flag: '🇨🇳', minLength: 11, maxLength: 11 },
  { code: '+57', country: 'Colombia', flag: '🇨🇴', minLength: 10, maxLength: 10 },
  { code: '+269', country: 'Comoros', flag: '🇰🇲', minLength: 7, maxLength: 7 },
  { code: '+242', country: 'Congo', flag: '🇨🇬', minLength: 9, maxLength: 9 },
  { code: '+506', country: 'Costa Rica', flag: '🇨🇷', minLength: 8, maxLength: 8 },
  { code: '+385', country: 'Croatia', flag: '🇭🇷', minLength: 9, maxLength: 9 },
  { code: '+53', country: 'Cuba', flag: '🇨🇺', minLength: 8, maxLength: 8 },
  { code: '+357', country: 'Cyprus', flag: '🇨🇾', minLength: 8, maxLength: 8 },
  { code: '+420', country: 'Czech Republic', flag: '🇨🇿', minLength: 9, maxLength: 9 },
  { code: '+45', country: 'Denmark', flag: '🇩🇰', minLength: 8, maxLength: 8 },
  { code: '+253', country: 'Djibouti', flag: '🇩🇯', minLength: 8, maxLength: 8 },
  { code: '+593', country: 'Ecuador', flag: '🇪🇨', minLength: 9, maxLength: 9 },
  { code: '+20', country: 'Egypt', flag: '🇪🇬', minLength: 10, maxLength: 10 },
  { code: '+503', country: 'El Salvador', flag: '🇸🇻', minLength: 8, maxLength: 8 },
  { code: '+240', country: 'Equatorial Guinea', flag: '🇬🇶', minLength: 9, maxLength: 9 },
  { code: '+291', country: 'Eritrea', flag: '🇪🇷', minLength: 7, maxLength: 7 },
  { code: '+372', country: 'Estonia', flag: '🇪🇪', minLength: 7, maxLength: 10 },
  { code: '+251', country: 'Ethiopia', flag: '🇪🇹', minLength: 9, maxLength: 9 },
  { code: '+679', country: 'Fiji', flag: '🇫🇯', minLength: 7, maxLength: 7 },
  { code: '+358', country: 'Finland', flag: '🇫🇮', minLength: 9, maxLength: 10 },
  { code: '+33', country: 'France', flag: '🇫🇷', minLength: 9, maxLength: 9 },
  { code: '+241', country: 'Gabon', flag: '🇬🇦', minLength: 7, maxLength: 8 },
  { code: '+220', country: 'Gambia', flag: '🇬🇲', minLength: 7, maxLength: 7 },
  { code: '+995', country: 'Georgia', flag: '🇬🇪', minLength: 9, maxLength: 9 },
  { code: '+49', country: 'Germany', flag: '🇩🇪', minLength: 10, maxLength: 11 },
  { code: '+233', country: 'Ghana', flag: '🇬🇭', minLength: 9, maxLength: 9 },
  { code: '+30', country: 'Greece', flag: '🇬🇷', minLength: 10, maxLength: 10 },
  { code: '+502', country: 'Guatemala', flag: '🇬🇹', minLength: 8, maxLength: 8 },
  { code: '+224', country: 'Guinea', flag: '🇬🇳', minLength: 9, maxLength: 9 },
  { code: '+245', country: 'Guinea-Bissau', flag: '🇬🇼', minLength: 7, maxLength: 7 },
  { code: '+592', country: 'Guyana', flag: '🇬🇾', minLength: 7, maxLength: 7 },
  { code: '+509', country: 'Haiti', flag: '🇭🇹', minLength: 8, maxLength: 8 },
  { code: '+504', country: 'Honduras', flag: '🇭🇳', minLength: 8, maxLength: 8 },
  { code: '+852', country: 'Hong Kong', flag: '🇭🇰', minLength: 8, maxLength: 8 },
  { code: '+36', country: 'Hungary', flag: '🇭🇺', minLength: 9, maxLength: 9 },
  { code: '+354', country: 'Iceland', flag: '🇮🇸', minLength: 7, maxLength: 7 },
  { code: '+91', country: 'India', flag: '🇮🇳', minLength: 10, maxLength: 10 },
  { code: '+62', country: 'Indonesia', flag: '🇮🇩', minLength: 9, maxLength: 12 },
  { code: '+98', country: 'Iran', flag: '🇮🇷', minLength: 10, maxLength: 10 },
  { code: '+964', country: 'Iraq', flag: '🇮🇶', minLength: 10, maxLength: 10 },
  { code: '+353', country: 'Ireland', flag: '🇮🇪', minLength: 9, maxLength: 9 },
  { code: '+972', country: 'Israel', flag: '🇮🇱', minLength: 9, maxLength: 9 },
  { code: '+39', country: 'Italy', flag: '🇮🇹', minLength: 10, maxLength: 10 },
  { code: '+225', country: 'Ivory Coast', flag: '🇨🇮', minLength: 10, maxLength: 10 },
  { code: '+81', country: 'Japan', flag: '🇯🇵', minLength: 10, maxLength: 10 },
  { code: '+962', country: 'Jordan', flag: '🇯🇴', minLength: 9, maxLength: 9 },
  { code: '+7', country: 'Kazakhstan', flag: '🇰🇿', minLength: 10, maxLength: 10 },
  { code: '+254', country: 'Kenya', flag: '🇰🇪', minLength: 10, maxLength: 10 },
  { code: '+965', country: 'Kuwait', flag: '🇰🇼', minLength: 8, maxLength: 8 },
  { code: '+996', country: 'Kyrgyzstan', flag: '🇰🇬', minLength: 9, maxLength: 9 },
  { code: '+856', country: 'Laos', flag: '🇱🇦', minLength: 9, maxLength: 10 },
  { code: '+371', country: 'Latvia', flag: '🇱🇻', minLength: 8, maxLength: 8 },
  { code: '+961', country: 'Lebanon', flag: '🇱🇧', minLength: 7, maxLength: 8 },
  { code: '+266', country: 'Lesotho', flag: '🇱🇸', minLength: 8, maxLength: 8 },
  { code: '+231', country: 'Liberia', flag: '🇱🇷', minLength: 7, maxLength: 8 },
  { code: '+218', country: 'Libya', flag: '🇱🇾', minLength: 10, maxLength: 10 },
  { code: '+423', country: 'Liechtenstein', flag: '🇱🇮', minLength: 7, maxLength: 9 },
  { code: '+370', country: 'Lithuania', flag: '🇱🇹', minLength: 8, maxLength: 8 },
  { code: '+352', country: 'Luxembourg', flag: '🇱🇺', minLength: 9, maxLength: 9 },
  { code: '+853', country: 'Macau', flag: '🇲🇴', minLength: 8, maxLength: 8 },
  { code: '+389', country: 'North Macedonia', flag: '🇲🇰', minLength: 8, maxLength: 8 },
  { code: '+261', country: 'Madagascar', flag: '🇲🇬', minLength: 9, maxLength: 10 },
  { code: '+265', country: 'Malawi', flag: '🇲🇼', minLength: 8, maxLength: 9 },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾', minLength: 9, maxLength: 10 },
  { code: '+960', country: 'Maldives', flag: '🇲🇻', minLength: 7, maxLength: 7 },
  { code: '+223', country: 'Mali', flag: '🇲🇱', minLength: 8, maxLength: 8 },
  { code: '+356', country: 'Malta', flag: '🇲🇹', minLength: 8, maxLength: 8 },
  { code: '+222', country: 'Mauritania', flag: '🇲🇷', minLength: 8, maxLength: 8 },
  { code: '+230', country: 'Mauritius', flag: '🇲🇺', minLength: 8, maxLength: 8 },
  { code: '+52', country: 'Mexico', flag: '🇲🇽', minLength: 10, maxLength: 10 },
  { code: '+373', country: 'Moldova', flag: '🇲🇩', minLength: 8, maxLength: 8 },
  { code: '+377', country: 'Monaco', flag: '🇲🇨', minLength: 8, maxLength: 9 },
  { code: '+976', country: 'Mongolia', flag: '🇲🇳', minLength: 8, maxLength: 8 },
  { code: '+382', country: 'Montenegro', flag: '🇲🇪', minLength: 8, maxLength: 9 },
  { code: '+212', country: 'Morocco', flag: '🇲🇦', minLength: 9, maxLength: 9 },
  { code: '+258', country: 'Mozambique', flag: '🇲🇿', minLength: 9, maxLength: 9 },
  { code: '+95', country: 'Myanmar', flag: '🇲🇲', minLength: 9, maxLength: 10 },
  { code: '+264', country: 'Namibia', flag: '🇳🇦', minLength: 9, maxLength: 10 },
  { code: '+674', country: 'Nauru', flag: '🇳🇷', minLength: 7, maxLength: 7 },
  { code: '+977', country: 'Nepal', flag: '🇳🇵', minLength: 10, maxLength: 10 },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱', minLength: 9, maxLength: 9 },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿', minLength: 9, maxLength: 10 },
  { code: '+505', country: 'Nicaragua', flag: '🇳🇮', minLength: 8, maxLength: 8 },
  { code: '+227', country: 'Niger', flag: '🇳🇪', minLength: 8, maxLength: 8 },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬', minLength: 10, maxLength: 10 },
  { code: '+850', country: 'North Korea', flag: '🇰🇵', minLength: 10, maxLength: 10 },
  { code: '+47', country: 'Norway', flag: '🇳🇴', minLength: 8, maxLength: 8 },
  { code: '+968', country: 'Oman', flag: '🇴🇲', minLength: 8, maxLength: 8 },
  { code: '+92', country: 'Pakistan', flag: '🇵🇰', minLength: 10, maxLength: 10 },
  { code: '+970', country: 'Palestine', flag: '🇵🇸', minLength: 9, maxLength: 9 },
  { code: '+507', country: 'Panama', flag: '🇵🇦', minLength: 8, maxLength: 8 },
  { code: '+675', country: 'Papua New Guinea', flag: '🇵🇬', minLength: 8, maxLength: 8 },
  { code: '+595', country: 'Paraguay', flag: '🇵🇾', minLength: 9, maxLength: 9 },
  { code: '+51', country: 'Peru', flag: '🇵🇪', minLength: 9, maxLength: 9 },
  { code: '+63', country: 'Philippines', flag: '🇵🇭', minLength: 10, maxLength: 10 },
  { code: '+48', country: 'Poland', flag: '🇵🇱', minLength: 9, maxLength: 9 },
  { code: '+351', country: 'Portugal', flag: '🇵🇹', minLength: 9, maxLength: 9 },
  { code: '+974', country: 'Qatar', flag: '🇶🇦', minLength: 8, maxLength: 8 },
  { code: '+40', country: 'Romania', flag: '🇷🇴', minLength: 10, maxLength: 10 },
  { code: '+250', country: 'Rwanda', flag: '🇷🇼', minLength: 9, maxLength: 9 },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦', minLength: 9, maxLength: 9 },
  { code: '+221', country: 'Senegal', flag: '🇸🇳', minLength: 9, maxLength: 9 },
  { code: '+381', country: 'Serbia', flag: '🇷🇸', minLength: 9, maxLength: 9 },
  { code: '+248', country: 'Seychelles', flag: '🇸🇨', minLength: 7, maxLength: 7 },
  { code: '+232', country: 'Sierra Leone', flag: '🇸🇱', minLength: 8, maxLength: 8 },
  { code: '+65', country: 'Singapore', flag: '🇸🇬', minLength: 8, maxLength: 8 },
  { code: '+421', country: 'Slovakia', flag: '🇸🇰', minLength: 9, maxLength: 9 },
  { code: '+386', country: 'Slovenia', flag: '🇸🇮', minLength: 9, maxLength: 9 },
  { code: '+252', country: 'Somalia', flag: '🇸🇴', minLength: 8, maxLength: 9 },
  { code: '+27', country: 'South Africa', flag: '🇿🇦', minLength: 9, maxLength: 9 },
  { code: '+82', country: 'South Korea', flag: '🇰🇷', minLength: 10, maxLength: 11 },
  { code: '+211', country: 'South Sudan', flag: '🇸🇸', minLength: 9, maxLength: 9 },
  { code: '+34', country: 'Spain', flag: '🇪🇸', minLength: 9, maxLength: 9 },
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰', minLength: 9, maxLength: 9 },
  { code: '+249', country: 'Sudan', flag: '🇸🇩', minLength: 9, maxLength: 9 },
  { code: '+597', country: 'Suriname', flag: '🇸🇷', minLength: 7, maxLength: 7 },
  { code: '+268', country: 'Eswatini', flag: '🇸🇿', minLength: 8, maxLength: 8 },
  { code: '+46', country: 'Sweden', flag: '🇸🇪', minLength: 9, maxLength: 9 },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭', minLength: 9, maxLength: 9 },
  { code: '+963', country: 'Syria', flag: '🇸🇾', minLength: 9, maxLength: 9 },
  { code: '+886', country: 'Taiwan', flag: '🇹🇼', minLength: 9, maxLength: 9 },
  { code: '+992', country: 'Tajikistan', flag: '🇹🇯', minLength: 9, maxLength: 9 },
  { code: '+255', country: 'Tanzania', flag: '🇹🇿', minLength: 9, maxLength: 9 },
  { code: '+66', country: 'Thailand', flag: '🇹🇭', minLength: 9, maxLength: 9 },
  { code: '+228', country: 'Togo', flag: '🇹🇬', minLength: 8, maxLength: 8 },
  { code: '+676', country: 'Tonga', flag: '🇹🇴', minLength: 7, maxLength: 7 },
  { code: '+216', country: 'Tunisia', flag: '🇹🇳', minLength: 8, maxLength: 8 },
  { code: '+90', country: 'Turkey', flag: '🇹🇷', minLength: 10, maxLength: 10 },
  { code: '+993', country: 'Turkmenistan', flag: '🇹🇲', minLength: 8, maxLength: 8 },
  { code: '+256', country: 'Uganda', flag: '🇺🇬', minLength: 9, maxLength: 9 },
  { code: '+380', country: 'Ukraine', flag: '🇺🇦', minLength: 9, maxLength: 9 },
  { code: '+971', country: 'UAE', flag: '🇦🇪', minLength: 9, maxLength: 9 },
  { code: '+44', country: 'UK', flag: '🇬🇧', minLength: 10, maxLength: 10 },
  { code: '+598', country: 'Uruguay', flag: '🇺🇾', minLength: 8, maxLength: 8 },
  { code: '+998', country: 'Uzbekistan', flag: '🇺🇿', minLength: 9, maxLength: 9 },
  { code: '+678', country: 'Vanuatu', flag: '🇻🇺', minLength: 7, maxLength: 7 },
  { code: '+58', country: 'Venezuela', flag: '🇻🇪', minLength: 10, maxLength: 10 },
  { code: '+84', country: 'Vietnam', flag: '🇻🇳', minLength: 9, maxLength: 10 },
  { code: '+967', country: 'Yemen', flag: '🇾🇪', minLength: 9, maxLength: 9 },
  { code: '+260', country: 'Zambia', flag: '🇿🇲', minLength: 9, maxLength: 9 },
  { code: '+263', country: 'Zimbabwe', flag: '🇿🇼', minLength: 9, maxLength: 9 },
];

// Remove popular countries from the main list to avoid duplicates
const popularCountryCodes = new Set(popularCountries.map(c => c.code));
const filteredCountries = allCountriesList.filter(c => !popularCountryCodes.has(c.code));

// Sort remaining countries alphabetically
const sortedCountries = filteredCountries.sort((a, b) => a.country.localeCompare(b.country));

// Combine: Popular countries first, then a separator, then sorted countries
export const countryCodes = [
  ...popularCountries,
  { code: 'separator', country: '─────── All Countries ───────', flag: '', minLength: 0, maxLength: 0, disabled: true },
  ...sortedCountries
];

// Helper function to get country by code
export const getCountryByCode = (code) => {
  return countryCodes.find(country => country.code === code && !country.disabled);
};

// Helper function to validate phone number for a specific country
export const validatePhoneNumber = (phoneNumber, countryCode) => {
  const country = getCountryByCode(countryCode);
  if (!country) return false;

  const phoneDigits = phoneNumber.replace(/\D/g, '');
  return phoneDigits.length >= country.minLength && phoneDigits.length <= country.maxLength;
};
